<!-- <button
  class="sort-button"
  (click)="sortColumn.emit()"
  [disabled]="!tableHasData"
>
  <ng-content></ng-content>
  <img
   
    [ngClass]="sortDirection"
    src="assets/icons/icon-sort-arrow.svg"
    alt=""
  >
  <mat-icon>arrow_upward</mat-icon>
<mat-icon>arrow_downward</mat-icon>
</button> -->

<button
  class="sort-button"
  (click)="sortColumn.emit()"
  [disabled]="!tableHasData"
>
  <ng-content></ng-content>
  <img
    *ngIf="tableHasData && isSorted"
    [ngClass]="sortDirection"
    src="assets/icons/icon-sort-arrow.svg"
    alt=""
  >
   <img
    *ngIf="!isSorted"
  style="padding-right: 0; height: 15px;"
    src="assets/icons/icon-sort-arrow.svg"
    alt=""
  >
   <img
  *ngIf="!isSorted"
    style="transform: rotate(180deg); padding: 0; height: 15px;"
    src="assets/icons/icon-sort-arrow.svg"
    alt=""
  >
  <!-- <mat-icon *ngIf="!isSorted" style="font-size: 17px;
    padding: 0;
    margin: 0;
    width: 14px;">arrow_upward</mat-icon>
<mat-icon *ngIf="!isSorted" style="font-size: 17px;
    width: auto;">arrow_downward</mat-icon> -->
</button>
